module.exports = __webpack_public_path__ + "img/JURIDICO.181e86fb.jpeg";